export default "__VITE_ASSET__60059792__"